module.exports = __webpack_public_path__ + "img/4.4d2933c0.gif";